// Vendor imports
const { createSelector } = require('reselect')
// Sibling imports
const allProviders = require('./providers')

const isVisible = createSelector(
  state => state.authModal,
  Boolean
)

const providers = () => allProviders

module.exports = {
  isVisible,
  providers
}
